// 全域：品牌設定 + 登入 session（SDK 的 session 是唯一真相，這裡只訂閱它）。
import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import type { KinioSession } from '@kinio/web-sdk';
import type { AppConfig } from './appConfig';
import { session } from './session';
import { initialMyCamMode, type MyCamMode } from '../features/shell/mycamMode';

interface AppState {
  config: AppConfig;
  session: KinioSession | null;
  /** MyCam 主機的呈現模式（簡易 / 完整）；不是 MyCam 主機一律 full。只改呈現，授權照舊由 API 決定（SPEC #mycam-617）。 */
  uiMode: MyCamMode;
  setUIMode(mode: MyCamMode): void;
}

const Ctx = createContext<AppState | null>(null);

export function AppProvider({ config, children }: { config: AppConfig; children: ReactNode }) {
  const [s, setS] = useState<KinioSession | null>(session.get());
  const key = `mycam-ui:${config.env}:${config.brand}`;
  const [uiMode, updateMode] = useState<MyCamMode>(() => {
    let saved: string | null = null;
    try {
      saved = localStorage.getItem(key);
    } catch {
      /* 私密模式照常使用 */
    }
    return initialMyCamMode(config, saved);
  });
  const setUIMode = (mode: MyCamMode) => {
    updateMode(mode);
    try {
      localStorage.setItem(key, mode);
    } catch {
      /* 不影響操作 */
    }
  };
  useEffect(() => session.subscribe(setS), []);
  return <Ctx.Provider value={{ config, session: s, uiMode, setUIMode }}>{children}</Ctx.Provider>;
}

export function useApp(): AppState {
  const v = useContext(Ctx);
  if (!v) throw new Error('useApp 要在 AppProvider 裡');
  return v;
}
